/**
 * A04 — Grand Livre: FE form ↔ BE situation_grand_livre column mapping.
 * Writable columns only (excludes id, grand_livre_ref, created_at, updated_at).
 */

export const GRAND_LIVRE_WRITABLE_FIELDS = [
  'exercice_fiscal',
  'periode_debut',
  'periode_fin',
  'date_etablissement',
  'type_edition',
  'statut_edition',
  'numero_compte',
  'libelle_compte',
  'compte_classe',
  'date_ecriture',
  'numero_piece',
  'libelle_ecriture',
  'journal_code',
  'journal_libelle',
  'montant_debit',
  'montant_credit',
  'solde_progressif_debit',
  'solde_progressif_credit',
  'solde_progressif_net',
  'sens_solde',
  'reference_externe',
  'numero_facture',
  'tiers_nom',
  'validation_ecriture',
  'validation_date',
  'validateur_nom',
  'lettrage_code',
  'lettrage_date',
  'lettrage_montant',
  'rapprochement_bancaire',
  'rapprochement_date',
  'analytique_affectation',
  'analytique_axes',
  'tva_code',
  'tva_montant',
  'tva_regime',
  'echeance_date',
  'echeance_statut',
  'annotations_comptable',
  'notes_correction',
  'piece_jointe_url',
  'piece_jointe_nombre',
  'origine_ecriture',
  'ecriture_bloquee',
  'ecriture_modifiable',
  'audit_trail',
  'modification_historique',
  'conformite_pcn',
  'verification_controle',
  'notes',
  'metadata',
  'created_by',
];

const DATE_FIELDS = new Set([
  'periode_debut',
  'periode_fin',
  'date_etablissement',
  'date_ecriture',
  'validation_date',
  'lettrage_date',
  'rapprochement_date',
  'echeance_date',
]);

const DECIMAL_FIELDS = new Set([
  'montant_debit',
  'montant_credit',
  'solde_progressif_debit',
  'solde_progressif_credit',
  'solde_progressif_net',
  'lettrage_montant',
  'tva_montant',
]);

const INTEGER_FIELDS = new Set([
  'piece_jointe_nombre',
  'ecriture_bloquee',
  'ecriture_modifiable',
  'conformite_pcn',
]);

export const EMPTY_GRAND_LIVRE_FORM = Object.freeze(
  GRAND_LIVRE_WRITABLE_FIELDS.reduce((acc, field) => {
    acc[field] = '';
    return acc;
  }, {})
);

const normalizeDate = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value.split('T')[0];
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().split('T')[0];
  }
  return String(value);
};

const toFormScalar = (field, value) => {
  if (value == null) return '';
  if (DATE_FIELDS.has(field)) return normalizeDate(value);
  if (INTEGER_FIELDS.has(field)) return value === 1 || value === true ? 1 : value === 0 || value === false ? 0 : value;
  return value;
};

/** Map API row → form state (all writable columns). */
export const recordToFormData = (record = {}) => {
  const form = { ...EMPTY_GRAND_LIVRE_FORM };
  GRAND_LIVRE_WRITABLE_FIELDS.forEach((field) => {
    if (record[field] !== undefined && record[field] !== null) {
      form[field] = toFormScalar(field, record[field]);
    }
  });
  return form;
};

/** Map form state → API payload (typed for situation_grand_livre). */
export const buildGrandLivrePayload = (formData = {}) => {
  const payload = {};

  GRAND_LIVRE_WRITABLE_FIELDS.forEach((field) => {
    const raw = formData[field];

    if (DECIMAL_FIELDS.has(field)) {
      payload[field] = raw === '' || raw == null ? 0 : parseFloat(raw) || 0;
      return;
    }

    if (INTEGER_FIELDS.has(field)) {
      if (raw === '' || raw == null) {
        payload[field] = field === 'ecriture_modifiable' ? 1 : field === 'conformite_pcn' ? 1 : 0;
        return;
      }
      payload[field] = raw === true || raw === 1 || raw === '1' ? 1 : 0;
      return;
    }

    if (DATE_FIELDS.has(field)) {
      payload[field] = raw === '' || raw == null ? null : normalizeDate(raw);
      return;
    }

    payload[field] = raw === '' || raw == null ? null : raw;
  });

  return payload;
};
